export const RefundPolicy = () => {
  return (
    <div>
      <p>Current edition: 24, June, 2025</p>
      <h3 class="header-h3">Refund policy</h3>
      <p>
        GravizApp company guarantees a refund to its clients on the following
        terms:
      </p>
      <ul>
        <li>
          User requested refund in no more than 7 days after making a payment
        </li>
        <li>Refund is provided only once per user</li>
        <li>
          There are no complaints of user's actions and user have not violated
          terms of service
        </li>
        <li>Dedicated IP are not eligible for a refund</li>
        <li>Refunds are made net of commission</li>
        <li>
          Refunds in cryptocurrency are made considering current cryptocurrency
          price
        </li>
        <li>
          We reserve the right to choose a way and a payment system for the
          refund
        </li>
      </ul>
      <h3 class="header-h3">How to request a refund</h3>
      <p>
        To request a refund user needs to make a request on the feedback page
        with the following information:
      </p>
      <ul>
        <li>Subject — "Refund"</li>
        <li>Active email address so we could contact you</li>
        <li>
          Information about the reasons for refunding and preferred method of
          receiving the money
        </li>
      </ul>
      <p>
        After receiving your request we will contact you to clarify the details
        of this request. All refunds are made in following terms:
      </p>
      <ul>
        <li>Electronic payments and mobile commerce — 7–14 days</li>
        <li>
          Credit/Debit cards — 14–30 days (depends on the processing speed of
          your bank)
        </li>
      </ul>
      <p>
        We hope you enjoy our services. But if something went wrong or our
        services does not fit your needs — we will make a refund without
        unnecessary difficulties.
      </p>
    </div>
  );
};

export const TermsOfService = () => {
  return (
    <div>
      <p>Current edition: April 02, 2026</p>
      <h3 class="header-h3">User Agreement</h3>
      <h3 class="header-h3">1. General provisions</h3>
      <p>
        1.1. This User Agreement (the "Agreement") regulates the use of the
        online service (the "Service") provided by the Administration.
      </p>
      <p>
        1.2. By using the Service, including launching the bot, registration,
        paying for services, or getting access to materials, the User confirms
        they have fully read and accepted this Agreement in full.
      </p>
      <p>
        1.3. If the User does not agree with the Agreement, they must stop using
        the Service.
      </p>
      <h3 class="header-h3">2. Nature of services and digital goods</h3>
      <p>
        2.1. The Service provides intangible digital goods and services,
        including but not limited to informational materials, educational
        programs, consultations, digital products, and service-related features.
      </p>
      <p>2.2. Materials provided through the Service may include:</p>
      <ul>
        <li>information from open sources;</li>
        <li>copyrighted materials of the Administration and/or third parties;</li>
        <li>
          analytical reviews, selections, recommendations, and structured data.
        </li>
      </ul>
      <p>
        2.3. The User understands and agrees that the value of the Service's
        digital goods and services lies in systematization, analysis, format of
        delivery, support, maintenance, and updates, and not in the exclusivity
        of separate information fragments.
      </p>
      <p>
        2.4. The Service does not claim or guarantee uniqueness, exclusivity, or
        unavailability of separate material elements outside the Service.
      </p>
      <h3 class="header-h3">3. Disclaimer of warranties and liability</h3>
      <p>3.1. The Service is provided on an "AS IS" basis.</p>
      <p>3.2. The Administration does not guarantee:</p>
      <ul>
        <li>that the Service will meet the User's expectations;</li>
        <li>
          achievement of any financial, commercial, professional, or other
          results;
        </li>
        <li>uninterrupted and error-free operation of the Service.</li>
      </ul>
      <p>3.3. The Administration is not liable for:</p>
      <ul>
        <li>any direct or indirect losses, including lost profit;</li>
        <li>consequences of the User applying received materials;</li>
        <li>actions or inaction of third parties;</li>
        <li>temporary technical failures and access restrictions.</li>
      </ul>
      <p>
        3.4. All decisions on applying materials, recommendations, and services
        are made by the User independently and at their own risk.
      </p>
      <h3 class="header-h3">4. Lawful use</h3>
      <p>
        4.1. The Service is not intended to encourage, organize, or facilitate
        unlawful activities.
      </p>
      <p>
        4.2. The User agrees to use the Service strictly within applicable laws
        and third-party rules.
      </p>
      <p>
        4.3. Responsibility for lawful use of Service materials and services lies
        fully with the User.
      </p>
      <h3 class="header-h3">5. Intellectual property</h3>
      <p>
        5.1. All materials published in the Service are protected by intellectual
        property law.
      </p>
      <p>
        5.2. The User may not copy, distribute, resell, transfer to third
        parties, or otherwise use Service materials without permission from the
        rights holder.
      </p>
      <p>
        5.3. Intellectual property violations may result in restricted access to
        the Service without compensation.
      </p>
      <h3 class="header-h3">6. Access limitation</h3>
      <p>
        6.1. The Administration may suspend or limit the User's access to the
        Service in case of:
      </p>
      <ol>
        <li>violation of this Agreement;</li>
        <li>detected abuse;</li>
        <li>requirements of law or payment providers.</li>
      </ol>
      <p>
        6.2. Access limitation does not release the User from obligations that
        arose earlier.
      </p>
      <p>
        6.3. The Administration reserves the right to refuse service to Users
        whose actions may create increased risks for the Service, payment
        providers, or third parties.
      </p>
      <h3 class="header-h3">7. Payments and refunds</h3>
      <p>
        7.1. Payment for services and digital goods is made under terms published
        in the Service before payment.
      </p>
      <p>
        7.2. Due to the intangible nature of digital goods and services, no
        refunds are made after access is granted, except in the cases listed
        below.
      </p>
      <p>7.3. A refund is possible only if:</p>
      <ul>
        <li>the service was not provided due to a technical fault of the Service;</li>
        <li>access to the digital product was not actually provided.</li>
      </ul>
      <p>
        7.4. To request a refund review, the User must contact support within 24
        hours from payment.
      </p>
      <p>7.5. Refund decisions are made by the Administration individually.</p>
      <p>
        7.6. The User confirms they will not initiate a payment chargeback
        through payment systems without first contacting Service support.
      </p>
      <h3 class="header-h3">8. Confidentiality</h3>
      <p>
        8.1. The Administration may collect minimal technical data required for
        Service operation.
      </p>
      <p>
        8.2. The Administration takes reasonable measures to protect data but does
        not guarantee absolute security of transmitted information.
      </p>
      <h3 class="header-h3">9. Changes to terms</h3>
      <p>9.1. The Administration may amend this Agreement.</p>
      <p>9.2. The current version of the Agreement is published in the Service.</p>
      <p>
        9.3. Continued use of the Service means acceptance of updated terms by the
        User.
      </p>
      <h3 class="header-h3">10. Contact information</h3>
      <p>
        10.1. For any questions, the User may contact support via the form inside
        the bot.
      </p>
      <p>
        By using the Service (including launching the bot and/or entering the
        /start command), the User confirms they have read this Agreement and
        accept it in full.
      </p>
    </div>
  );
};

export const PrivacyPolicy = () => {
  return (
    <div>
      <p>Current edition: October 15, 2026</p>
      <h3 class="header-h3">Privacy Policy</h3>
      <p>
        This Privacy Policy governs collection, use, and protection of information
        of Service users.
      </p>
      <p>
        Account identifiers, technical information, and interaction history may
        be collected. Data is used to operate the Service, communicate with the
        User, and perform analysis.
      </p>
      <p>
        Transfer of information to third parties is possible only in cases
        established by law or with the User's consent.
      </p>
      <p>
        Data is stored for the period necessary to achieve processing purposes,
        and protected within reasonable limits. The User is responsible for risks
        related to data transfer.
      </p>
      <p>
        The Administration may update this Policy without notice; continued use
        of the Service means acceptance.
      </p>
      <h3 class="header-h3">1. General provisions</h3>
      <p>
        1.1. This Privacy Policy (the "Policy") regulates the processing and
        protection of information provided by the User when using the Service.
      </p>
      <p>
        1.2. By using the Service, the User confirms agreement with this Policy.
        If the User disagrees with the Policy, they must stop using the Service.
      </p>
      <h3 class="header-h3">2. Information collection</h3>
      <p>2.1. The Service may collect the following types of data:</p>
      <ul>
        <li>account identifiers (email, telegramID);</li>
        <li>
          technical information (account settings, a password encrypted with a strong cryptographic algorithm, subscription credentials, the balance of funds in the personal account, etc.);
        </li>
        <li>interaction history with the Service (information about purchased subscriptions, date and time of payment).</li>
      </ul>
      <p>
        2.2. The Service does not require passport data, documents, photographs,
        or other personal information.
      </p>
        2.3. The Service does not collect or store Users IP addresses, nor does it keep records of the addresses of resources visited by them, data received or transmitted, etc. The Service servers do not contain any records or log files that would allow any activity to be associated with a specific User.
      <p>
      </p>
      <h3 class="header-h3">3. Use of information</h3>
      <p>3.1. The Service may use collected information exclusively for:</p>
      <ul>
        <li>ensuring operation of Service functionality;</li>
        <li>communication with the User, including notifications and support;</li>
        <li>analysis and improvement of the Service.</li>
      </ul>
      <h3 class="header-h3">4. Transfer to third parties</h3>
      <p>
        4.1. The Administration does not transfer obtained data to third parties,
        except in the following cases:
      </p>
      <ul>
        <li>when required by law;</li>
        <li>
          when needed to fulfill obligations to the User (for example, when
          working with payment systems);
        </li>
        <li>when the User gave explicit consent.</li>
      </ul>
      <h3 class="header-h3">5. Data storage and protection</h3>
      <p>
        5.1. Data is stored for the period required to achieve processing
        purposes.
      </p>
      <p>
        5.2. The Administration takes reasonable measures to protect data. The collected data constitute a trade secret and are stored on a dedicated server; access to this server — including for maintenance purposes — is restricted exclusively to Service personnel.
      </p>
      <h3 class="header-h3">6. Limitation of liability</h3>
      <p>
        6.1. The Administration is not liable for loss, theft, or disclosure of
        data if it happened due to actions of third parties or the User.
      </p>
      <h3 class="header-h3">7. Policy updates</h3>
      <p>
        7.1. The Administration may amend the Policy without prior notice.
      </p>
      <p>
        7.2. Continued use of the Service after changes means the User agrees
        with the updated Policy.
      </p>
    </div>
  );
};

export default {
  RefundPolicy,
  TermsOfService,
  PrivacyPolicy,
};
